import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Invalid2lchzzxcoxbzy as Invalid,
  Warning3n5ye4cehejrw as Warning,
  IssueNode2x8c6ia7dmfdz as IssueNode,
} from './IssueNode.mjs';
import {
  checkForIssue33eljrw8xgf34 as checkForIssue,
  checkForIssuekofyrsbkkylg as checkForIssue_0,
  checkForIssue1hr94zacaxdsk as checkForIssue_1,
  checkForIssue13p10uahnmugb as checkForIssue_2,
} from './validation.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function assert(_this__u8e3s4, summary, description, setOnIssue, condition) {
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return checkForIssue(_this__u8e3s4, (it) => {
    var tmp;
    if (condition(it)) {
      return null;
    }
    return setOnIssue ? new (Warning())(summary, description) : new (Invalid())(summary, description);
  });
}
function assertNotBlank(_this__u8e3s4, summary, description, setOnIssue) {
  summary = summary === VOID ? 'Cannot be blank' : summary;
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return assert(_this__u8e3s4, summary, description, setOnIssue, assertNotBlank$lambda);
}
function assertNotBlank_0(_this__u8e3s4, summary, description, setOnIssue) {
  summary = summary === VOID ? 'Cannot be blank' : summary;
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return assert_0(_this__u8e3s4, summary, description, setOnIssue, assertNotBlank$lambda_0);
}
function assertNotNull(_this__u8e3s4, summary, description, setOnIssue) {
  summary = summary === VOID ? 'Cannot be blank' : summary;
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return assert_0(_this__u8e3s4, summary, description, setOnIssue, assertNotNull$lambda);
}
function validateReactive(_this__u8e3s4, issue) {
  return report(_this__u8e3s4, ($this$report) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp0_safe_receiver = issue($this$report, $this$report.daj(_this__u8e3s4));
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new (Warning())(tmp0_safe_receiver);
    }
    return tmp;
  });
}
function assert_0(_this__u8e3s4, summary, description, setOnIssue, condition) {
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return checkForIssue_0(_this__u8e3s4, (it) => {
    var tmp;
    if (condition(it)) {
      return null;
    }
    return setOnIssue ? new (Warning())(summary, description) : new (Invalid())(summary, description);
  });
}
function assertNotNull_0(_this__u8e3s4, summary, description, setOnIssue) {
  summary = summary === VOID ? 'Cannot be blank' : summary;
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return assert(_this__u8e3s4, summary, description, setOnIssue, assertNotNull$lambda_0);
}
function assertReactive(_this__u8e3s4, summary, description, condition) {
  description = description === VOID ? summary : description;
  return report(_this__u8e3s4, ($this$report) => {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    if (condition($this$report, $this$report.daj(_this__u8e3s4))) {
      tmp = null;
    } else {
      tmp = new (Warning())(summary, description);
    }
    return tmp;
  });
}
function validate(_this__u8e3s4, setOnIssue, validate) {
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return checkForIssue_0(_this__u8e3s4, (value) => {
    var tmp0_safe_receiver = validate(value);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = setOnIssue ? new (Warning())(tmp0_safe_receiver) : new (Invalid())(tmp0_safe_receiver);
    }
    return tmp;
  });
}
function assertNotBlank_1(_this__u8e3s4, summary, description, setOnIssue) {
  summary = summary === VOID ? 'Cannot be blank' : summary;
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return assert_2(_this__u8e3s4, summary, description, setOnIssue, assertNotBlank$lambda_1);
}
function assert_1(_this__u8e3s4, summary, description, setOnIssue, condition) {
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return checkForIssue_1(_this__u8e3s4, (it) => {
    var tmp;
    if (condition(it)) {
      return null;
    }
    return setOnIssue ? new (Warning())(summary, description) : new (Invalid())(summary, description);
  });
}
function validate_0(_this__u8e3s4, setOnIssue, validate) {
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return checkForIssue_2(_this__u8e3s4, (value) => {
    var tmp0_safe_receiver = validate(value);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = setOnIssue ? new (Warning())(tmp0_safe_receiver) : new (Invalid())(tmp0_safe_receiver);
    }
    return tmp;
  });
}
function validate_1(_this__u8e3s4, setOnIssue, validate) {
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return checkForIssue(_this__u8e3s4, (value) => {
    var tmp0_safe_receiver = validate(value);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = setOnIssue ? new (Warning())(tmp0_safe_receiver) : new (Invalid())(tmp0_safe_receiver);
    }
    return tmp;
  });
}
function assert_2(_this__u8e3s4, summary, description, setOnIssue, condition) {
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return checkForIssue_2(_this__u8e3s4, (it) => {
    var tmp;
    if (condition(it)) {
      return null;
    }
    return setOnIssue ? new (Warning())(summary, description) : new (Invalid())(summary, description);
  });
}
function assertNotNull_1(_this__u8e3s4, summary, description, setOnIssue) {
  summary = summary === VOID ? 'Cannot be blank' : summary;
  description = description === VOID ? summary : description;
  setOnIssue = setOnIssue === VOID ? true : setOnIssue;
  return assert_2(_this__u8e3s4, summary, description, setOnIssue, assertNotNull$lambda_1);
}
function report(_this__u8e3s4, issue) {
  var child = new (IssueNode())(_this__u8e3s4.xat());
  child.wat();
  child.uat(issue);
}
function assertNotBlank$lambda(it) {
  // Inline function 'kotlin.text.isNotBlank' call
  return !isBlank(it);
}
function assertNotBlank$lambda_0(it) {
  // Inline function 'kotlin.text.isNotBlank' call
  return !isBlank(it);
}
function assertNotNull$lambda(it) {
  return !(it == null);
}
function assertNotNull$lambda_0(it) {
  return !(it == null);
}
function assertNotBlank$lambda_1(it) {
  // Inline function 'kotlin.text.isNotBlank' call
  return !isBlank(it);
}
function assertNotNull$lambda_1(it) {
  return !(it == null);
}
//region block: exports
export {
  assertNotBlank_1 as assertNotBlank1cpq7aqdam42n,
  assertNotBlank_0 as assertNotBlankk8x8axj5z9hq,
  assertNotBlank as assertNotBlank3rcqh0n27fq5q,
  assertNotNull as assertNotNull3tylj1kgh6bbg,
  assertNotNull_1 as assertNotNull1uaw2iegqzgw8,
  assertNotNull_0 as assertNotNull37l8a72xnu5i6,
  assertReactive as assertReactive30c64mz7ckt8m,
  assert_0 as assert1ckwbdkg35i20,
  assert_2 as assert1g4x8g8kl5hay,
  assert as assert3pektuc8qw5gc,
  assert_1 as assert17rxqees4r4of,
  validateReactive as validateReactive3qltvv4cs75dh,
  validate_1 as validate2pui9cukx7dk9,
  validate as validateus3ow1e5uncs,
  validate_0 as validateni5d50psvu9d,
};
//endregion

//# sourceMappingURL=helpers.mjs.map
